import React from "react";

import PropTypes from "prop-types";
import { Highlight } from "react-instantsearch-dom";

import LinkWrapper from "~components/utils/link_wrapper/link_wrapper";

import { LINK } from "../../../../../../prop_types";
import {
  labelTitleStyle,
  searchResultItemStyle,
  searchResultItemTitleStyle,
} from "./search_instant_dropdown_result.module.scss";

export default function SearchInstantDropdownResult({ hit }) {
  return (
    <LinkWrapper link={hit.link}>
      <div className={searchResultItemStyle}>
        {hit.labelTitle && (
          <div className={labelTitleStyle}>{hit.labelTitle}</div>
        )}
        <div className={searchResultItemTitleStyle}>
          <Highlight attribute="title" hit={hit} tagName="mark" />
        </div>
      </div>
    </LinkWrapper>
  );
}

SearchInstantDropdownResult.propTypes = {
  hit: PropTypes.shape({
    link: LINK,
    labelTitle: PropTypes.string,
  }).isRequired,
};
